import { render, staticRenderFns } from "./RiskAssessmentOutput.vue?vue&type=template&id=99a56684&scoped=true&"
import script from "./RiskAssessmentOutput.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentOutput.vue?vue&type=script&lang=js&"
import style0 from "./RiskAssessmentOutput.vue?vue&type=style&index=0&id=99a56684&lang=scss&scoped=true&"
import style1 from "./RiskAssessmentOutput.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a56684",
  null
  
)

export default component.exports